import React from 'react';
import { NextPage, GetStaticProps } from 'next';
import Link from 'next/link';
import Head from 'next/head';
import { css } from '@emotion/react';
import { Headline, Body, Button } from '@sumup-oss/circuit-ui';
import { useTranslation } from 'next-i18next';
import styled from '@emotion/styled';

import { Logo } from 'components/Logo';
import Card from 'components/FixedCard';
import { getErrorStaticProps } from 'services/staticGeneration/error';

interface ErrorPageProps {
  statusCode?: number;
}

const Container = styled('section')(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 450px;
    margin: 0 auto 12px;
  `,
);

const ErrorPage: NextPage<ErrorPageProps> = ({ statusCode }) => {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{t('common.error_title')}</title>
      </Head>
      <Container>
        <a href="https://sumup.com" target="_blank" rel="noopener noreferrer">
          <Logo />
        </a>
        <Card>
          <Headline as="h2" size="l">
            {t('common.error_title')}
          </Headline>
          <Body>{statusCode && `${t('common.error_message')}`}</Body>

          <Card>
            <Button onClick={() => window.location.reload()}>
              {t('common.reload_page')}
            </Button>
            <Link href="/" passHref legacyBehavior>
              <Button variant="primary">{t('common.go_to_homepage')}</Button>
            </Link>
          </Card>
        </Card>
      </Container>
    </>
  );
};

export const getStaticProps: GetStaticProps = getErrorStaticProps;

export default ErrorPage;
